const password = [
    { type: 'required', message: 'Password is required' },
    { type: 'minlength', message: 'Password must be at least 5 characters long' },
    { type: 'pattern', message: 'Your password must contain at least one uppercase, one lowercase, one number and the symbols ( !*@#$%^&+= )' },
    { type: 'areEqual', message: 'You entered wrong password' },
]

export default { password };